import api from './api';

const employeeReportsService = {
  // Get employee expense reports
  getEmployeeReports: async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      
      if (filters.startDate) params.append('startDate', filters.startDate);
      if (filters.endDate) params.append('endDate', filters.endDate);
      if (filters.employeeId) params.append('employeeId', filters.employeeId);
      if (filters.department) params.append('department', filters.department);

      const queryString = params.toString();
      const url = `/employee-reports/reports${queryString ? `?${queryString}` : ''}`;
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error getting employee reports:', error);
      throw error;
    }
  },

  // Get employee filter options
  getEmployeeFilterOptions: async () => {
    try {
      const response = await api.get('/employee-reports/filters');
      return response.data;
    } catch (error) {
      console.error('Error getting employee filter options:', error);
      throw error;
    }
  }
};

export default employeeReportsService;

